import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";

import { GET_EMDR_INBOX_LIST } from "../services/get-emdr-inbox-list";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { HIDE_LOADER, SHOW_LOADER } from "../../../../common_components/mdae-common-reducer";
import { ATTACHMENT_LEVEL_NAME, EMDR_INBOX_PAGE_TABS, EMDR_ATTACH_POPUP_MODE } from "../../constant";
import { actions, callOperation } from "async-ops";
import { MARK_DOCUMENT_AS_ARCHIEVE } from "../services/mark-document-as-archieve";
import mdaeNotify, { NOTIFY_MESSAGE_TYPE } from "../../../../common_components/common_widgets/toast/notify";
import { ATTACH_DOCUMENT } from "../../../../common_components/document-management/services/attach-documents";
import { toggleAttachedDocumentToAuditOrCasePopup } from "../attached-document-to-audit-or-case-pop-up";
import { MARK_EMDR_DOCUMENT_AS_SEEN } from "../services/mark-document-as-seen";
import { updateCount } from "../component";
import { bindActionCreators } from "redux";

export const TOGGLE_EMDR_INBOX_LIST_ACTION_POPOVER =
  "TOGGLE_EMDR_INBOX_LIST_ACTION_POPOVER";
export const SET_EMDR_INBOX_TAB_VISIBLE = "SET_EMDR_INBOX_TAB_VISIBLE";
export const SET_EMDR_INBOX_SELECTED_INDEX = "SET_EMDR_INBOX_SELECTED_INDEX";
export const SET_EMDR_INBOX_TYPE = "SET_EMDR_INBOX_TYPE";
export const SET_DOCUMENT_COUNT = "SET_DOCUMENT_COUNT";
export const TOGGLE_ATTACHED_AUDIT_CASE_POPUP =
  "TOGGLE_ATTACHED_AUDIT_CASE_POPUP";

const initialState = {
  eMDRInboxList: [],
  type: null,
  count: 0, // initial count state
  headerRangeFilterCount: 6,
  isAttachedDocumentToAuditOrCasePopupVisible: false,
  documentId: null,
  attachPopupMode: EMDR_ATTACH_POPUP_MODE.ATTACH_DOCUMENT,
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_EMDR_INBOX_LIST_ACTION_POPOVER:
    case SET_EMDR_INBOX_TAB_VISIBLE:
    case SET_EMDR_INBOX_SELECTED_INDEX:
    case SET_EMDR_INBOX_TYPE:
    case TOGGLE_ATTACHED_AUDIT_CASE_POPUP:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_EMDR_INBOX_LIST)(action)) {
        return {
          ...state,
          eMDRInboxList: [],
        };
      }
      if (isAsyncComplete(GET_EMDR_INBOX_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          eMDRInboxList: response.eMDRInboxList,
        };
      }
      return state;
    case SET_DOCUMENT_COUNT:
      return {
        ...state,
        count: action.data.count,
      };
    default:
      return state;
  }
}

 export const attachedDocumentToAuditsOrCases = (auditListDataGridInstance) =>
  (dispatch, getState) => {
    try {
      const asyncAction = bindActionCreators(
        {
          asyncOperationStart: actions.asyncOperationStart,
        },
        dispatch
      );
      const documentId = getState()["emdrInboxReducer"].documentId;
      const selectedCaseDetailIdsToAttachDocument = getState()["eacaseFieldsReducer"].selectedCaseDetailIdsToAttachDocument
      let selectedEMDRAuditList = auditListDataGridInstance
        ?.getSelectedRowsData()
        .map((e) => ({
          id: e.eaAuditId,
          name: ATTACHMENT_LEVEL_NAME.EXTERNAL_AUDIT,
        }));
      let selectedAuditcaseList = selectedCaseDetailIdsToAttachDocument?.map(
        (id) => ({
          id: id,
          name: ATTACHMENT_LEVEL_NAME.EXTERNAL_AUDIT_CASE,
        })
      );

      let selectedAuditAndCaseList = [
        ...selectedEMDRAuditList,
        ...selectedAuditcaseList,
      ];
      if(selectedAuditAndCaseList?.length > 0){
        let attachDocumentPromises = [];
        dispatch({ type: SHOW_LOADER });
        toggleAttachedDocumentToAuditOrCasePopup(
          dispatch,
          false,
          documentId
        );
        selectedAuditAndCaseList.forEach((element) => {
          attachDocumentPromises.push(callOperation(ATTACH_DOCUMENT, {
            documentId: documentId,
            attachedLevelId: element.id,
            attachedLevelName: element.name,
          }));
        })

        Promise.all(attachDocumentPromises).then(function (response) {
          dispatch({ type: HIDE_LOADER });
          callOperation(MARK_DOCUMENT_AS_ARCHIEVE, {
            documentId: documentId,
            type: EMDR_INBOX_PAGE_TABS.INBOX_TAB,
          }).then(function (response) {
            dispatch(actions.asyncOperationStart(MARK_EMDR_DOCUMENT_AS_SEEN,{
              documentId: documentId,
            }))
            updateCount(dispatch);
            dispatch(
              actions.asyncOperationStart(GET_EMDR_INBOX_LIST, {
                type: EMDR_INBOX_PAGE_TABS.INBOX_TAB,
              })
            );
          });
          mdaeNotify({
          message: "Letter has been attached successfully.",
            messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
          });
          if (selectedEMDRAuditList?.length > 0) {
            selectedEMDRAuditList.forEach((audit) => {
              if (audit?.id) {
                window.open(
                  `/externalaudit/audit?auditId=${audit.id}`,
                  "_blank"
                );
              }
            });
          }
          if (selectedAuditcaseList?.length > 0) {
            const auditList = getState()["auditListReducer"].auditList;
            const allCases = auditList?.flatMap(
              (audit) => audit.auditCasesList || []
            );
            selectedAuditcaseList.forEach((eaCase) => {
              const eaCaseId = eaCase?.id;
              const matchedCase = allCases?.find(
                (item) => item.eaCaseId === eaCaseId
              );
              const eaAuditId = matchedCase?.eaAuditId;
              if (eaCaseId && eaAuditId) {
                window.open(
                  `/externalaudit/audit?auditId=${eaAuditId}&eacaseid=${eaCaseId}`,
                  "_blank"
                );
              }
            });
          }
        });
      }else{
        mdaeNotify({
          message: "Please select atleast one audit or case to attach document.",
          messageType: NOTIFY_MESSAGE_TYPE.ERROR,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
